import store from '../store/store';
import permissionManager from "@/service/manager/permissionManager";

export const isCanAction = async (to, from, next) => {
    const permissions = store.getters.userPermissions;
    const propertyName = permissionManager.getPropertyName(to);

    if (!permissions[propertyName]) {
        next({ name: 'enterprise-list' });
    } else {
        next();
    }
};

export const isCanViewExemptions = async (to, from, next) => {
    const permissions = store.getters.userPermissions;

    if (!permissions.isCanViewExemptions) {
        next({ name: 'enterprise-list' });
    } else {
        next();
    }
};

export const isCanDuesAction = async (to, from, next) => {
    const { id } = to.params;
    const permissions = await store.getters.userPermissions;
    const propertyName = id && id !== 'undefined' ? 'isCanCreateDues' : 'isCanEditDues'

    if (!permissions[propertyName]) {
        next({ name: 'enterprise-list' });
    } else {
        next();
    }
};

export const isCanViewDues = async (to, from, next) => {
    const permissions = store.getters.userPermissions;

    if (!permissions.isCanViewDues) {
        next({ name: 'enterprise-list' });
    } else {
        next();
    }
};

export const isCanEditExemptions = async (to, from, next) => {
    const permissions = store.getters.userPermissions;

    if (!permissions.isCanEditExemptions) {
        next({ name: 'enterprise-list' });
    } else {
        next();
    }
};

export const isCanMakeDueEffective = async (to, from, next) => {
    const permissions = store.getters.userPermissions;

    if (!permissions.isCanMakeDueEffective) {
        next({ name: 'enterprise-list' });
    } else {
        next();
    }
};
